/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartDto
 */
export interface PartDto {
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    partId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    ns?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    partClass?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    prose?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    controlName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    parentPartId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartDto
     */
    parentPartName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartDto
     */
    hasSubParts?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PartDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PartDto
     */
    updated?: Date;
}

/**
 * Check if a given object implements the PartDto interface.
 */
export function instanceOfPartDto(value: object): value is PartDto {
    return true;
}

export function PartDtoFromJSON(json: any): PartDto {
    return PartDtoFromJSONTyped(json, false);
}

export function PartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'name': json['name'] == null ? undefined : json['name'],
        'ns': json['ns'] == null ? undefined : json['ns'],
        'partClass': json['partClass'] == null ? undefined : json['partClass'],
        'title': json['title'] == null ? undefined : json['title'],
        'prose': json['prose'] == null ? undefined : json['prose'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlName': json['controlName'] == null ? undefined : json['controlName'],
        'parentPartId': json['parentPartId'] == null ? undefined : json['parentPartId'],
        'parentPartName': json['parentPartName'] == null ? undefined : json['parentPartName'],
        'hasSubParts': json['hasSubParts'] == null ? undefined : json['hasSubParts'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function PartDtoToJSON(json: any): PartDto {
    return PartDtoToJSONTyped(json, false);
}

export function PartDtoToJSONTyped(value?: PartDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partId': value['partId'],
        'name': value['name'],
        'ns': value['ns'],
        'partClass': value['partClass'],
        'title': value['title'],
        'prose': value['prose'],
        'controlId': value['controlId'],
        'controlName': value['controlName'],
        'parentPartId': value['parentPartId'],
        'parentPartName': value['parentPartName'],
        'hasSubParts': value['hasSubParts'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}

